export const getPublicRoomAnimationStyle = (isShowFadeIn) => ({
  position: 'relative',
  ...isShowFadeIn ? {
    opacity: 0,
    transform: 'translateY(20px)',
    animation: 'fadeInUp 0.5s ease-out forwards',
    overflow: 'hidden',
  } : {},
});
